import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PerformanceFlagStore = {
  disableWorkflow: boolean;
  disableNewReplyNotifications: boolean;
  disableMyActivitiesSidebar: boolean;
  disableActivityOpenNotification: boolean;
  disableFooterTabs: boolean;
  useNewItineraryVersion: boolean;
  useNewQuoteVersion: boolean;
  usePostmarkInvoiceGeneration: boolean;
  useGdsChanges: boolean;
  setUseGdsChanges: (enable: boolean) => void;
  useReconciliationDashboard: boolean;
  useProjectContainerBookings: boolean;
  setDisableWorkflow: (disable: boolean) => void;
  setDisableNewReplyNotifications: (disable: boolean) => void;
  setDisableMyActivitiesSidebar: (disable: boolean) => void;
  setDisableActivityOpenNotification: (disable: boolean) => void;
  setDisableFooterTabs: (disable: boolean) => void;
  setUsePostmarkInvoiceGeneration: (enable: boolean) => void;
  setUseReconciliationDashboard: (enable: boolean) => void;
  setUseProjectContainerBookings: (enable: boolean) => void;
  toggleAll: (disable: boolean) => void;
};

export const usePerformanceFlagStore = create(
  persist<PerformanceFlagStore>(
    (set) => ({
      disableWorkflow: false,
      disableNewReplyNotifications: false,
      disableMyActivitiesSidebar: false,
      disableActivityOpenNotification: false,
      disableFooterTabs: false,
      useNewItineraryVersion: false,
      useNewQuoteVersion: false,
      usePostmarkInvoiceGeneration: false,
      useGdsChanges: false,
      setUseGdsChanges: (enable) => set({ useGdsChanges: enable }),
      useReconciliationDashboard: false,
      useProjectContainerBookings: false,
      setDisableWorkflow: (disable) => set({ disableWorkflow: disable }),
      setDisableNewReplyNotifications: (disable) => set({ disableNewReplyNotifications: disable }),
      setDisableMyActivitiesSidebar: (disable) => set({ disableMyActivitiesSidebar: disable }),
      setDisableActivityOpenNotification: (disable) => set({ disableActivityOpenNotification: disable }),
      setDisableFooterTabs: (disable) => set({ disableFooterTabs: disable }),
      setUsePostmarkInvoiceGeneration: (enable) => set({ usePostmarkInvoiceGeneration: enable }),
      setUseReconciliationDashboard: (enable) => set({ useReconciliationDashboard: enable }),
      setUseProjectContainerBookings: (enable) => set({ useProjectContainerBookings: enable }),
      toggleAll: (disable) =>
        set({
          disableWorkflow: disable,
          disableNewReplyNotifications: disable,
          disableMyActivitiesSidebar: disable,
          disableActivityOpenNotification: disable,
          disableFooterTabs: disable
        })
    }),
    {
      name: 'performance-flags'
    }
  )
);
